import { useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {  createTheme, ThemeProvider } from '@mui/material/styles';
import colors from "assets/theme/base/colors";
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import {Link} from 'react-router-dom';
import gcp from 'assets/images/illustrations/gcp.png';
import useMediaQuery from '@mui/material/useMediaQuery';

const defaultTheme = createTheme({
    palette: {...colors},
    typography: {
      button: {
        textTransform: 'none'
      },
    },
    img: {
        filter: "brightness(50%)",
    },
}); 

// Intelligently detecting unauthorized use and access in your business applications
  
export default function GCP() {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  
  useEffect(() =>{
    document.title = 'GCP Cloud Asset Protection';
    window.scrollTo(0,0)
   })
  return (
     <>
     <Box
        minHeight="40rem"
        width="100%"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Grid container maxWidth="lg" spacing={2} p={2} mt={8} sx={{ minHeight: "350px"}}  justifyContent="center" alignItems="center">
          <Grid item xs={12} p={2} textAlign="center">
            <Typography textAlign="center" sx={{ typography: { xs: 'h4', md: 'h1'}, mt: { xs: 6}}} fontWeight="fontWeightMedium" color="darkgreen.main" >
              AI-Powered Security <br />for Google Cloud Platform.
            </Typography>
            <Box sx={{ maxWidth: isMobile ? '90%' : '60%'}} m="auto">
              <Typography textAlign="center" variant="h5" color="grey.800"  sx={{ typography: { xs: 'body1', md: 'h5'}, mt: { xs: 4, md: 5}, mb: { xs: 4, md: 5}}} fontWeight='medium'>
                Detect any active threat against your tenant in as little as one minute. Eliminating the need for attack-specific detection.               
              </Typography>    
            </Box>
            <Link to="https://app.trawlai.com/sign-up" target="_blank">
               <Button
                                id="login-button"
                                size="large"
                                color="trawlgreen"
                                key="signup"
                                variant="contained"
                                sx={{pl: 5, pr: 5, marginTop: '50px'}}
                            >
                      <Typography sx={{ fontSize: "1.3em" }} color="grey.100">Get started today for free</Typography>
              </Button>
            </Link>
          </Grid>
          <Grid item xs={0} md={6} >
         
        </Grid>
        </Grid>
      </Box>
    <Box
    minHeight="40rem"
    width="100%"
    variant="gradient"
    bgcolor="darkgreen.main"
    sx={{
      backgroundSize: "cover",
      backgroundPosition: "top",
      display: "grid",
      placeItems: "center",
    }}
  >
   <Grid container maxWidth="lg" spacing={2} p={2} mt={2} sx={{ minHeight: "350px"}} >
    <Grid item xs={12} md={6} p={2}>
      <Typography variant="h2" color="white.main" fontWeight='fontWeightMedium'>
        Asset Protection for Google Cloud Platform.
      </Typography>
      <Typography variant="h4" color="white.main">
        Beta Coming Soon
      </Typography>
      <Link to="/contact-us" >
        <Button 
            sx={{ marginTop: '50px'}}
            id="learnmore-button"
            disableElevation
            color="light"
            key="learnmore"
            variant="contained" 
            size="lg">
                <Typography sx={{ fontSize: "1.3em" }} color="black.main">Contact Us For Availability</Typography>
        </Button>
      </Link>
    </Grid>
    <Grid item xs={0} md={6} >
          <Box  style={{
            backgroundImage: `url(${gcp})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            height: "100%",
          }}> 
            
          </Box>
        </Grid>
   </Grid>
  </Box>

  </>
  );
}


